import { useTranslation } from "react-i18next";

import styles from "./landing-page.module.css";
import { DemoSection } from "./sections/demo-section/demo-section";
import { EscapeRoomOverview } from "./sections/escape-room-overview-section/escape-room-overview";
import { FAQSection } from "./sections/faq-section";
import { FeatureSection } from "./sections/feature-section";
import { HeroSection } from "./sections/hero-section/hero-section";

export const LandingPage = () => {
    const { t } = useTranslation();

    const raw = t("escaperooms", { returnObjects: true, interpolation: { skipOnVariables: false } });
    const escapeRoomsData = Array.isArray(raw) ? raw : [];
    return (
        <div className={styles.landingPage}>
            <HeroSection />
            <FeatureSection />
            <DemoSection escapeRooms={escapeRoomsData} />
            <EscapeRoomOverview escapeRooms={escapeRoomsData} />
            <FAQSection />
        </div>
    );
};
